import { render } from "./PageFooters.vue?vue&type=template&id=7f08efbf&scoped=true"
import script from "./PageFooters.vue?vue&type=script&lang=js"
export * from "./PageFooters.vue?vue&type=script&lang=js"

import "./PageFooters.vue?vue&type=style&index=0&id=7f08efbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f08efbf"]])

export default __exports__